<template>
  <div>
    <div>
    <span v-for="(author, index) in authors">
      <span class=""
            v-bind:class="[{ 'underline': (author.role_id == 2 && settings.authors.authorline.underline.presenter) || (author.role_id == 1 && settings.authors.authorline.underline.author)}]">{{getAuthorFirstname(author.firstname)}} {{getAuthorLastname(author.lastname)}}</span><sup
      v-for="(institute, instindex) in author.institute">{{institute.affiliation_counter}}<span
      v-if="instindex < author.institute.length-1">,&nbsp;</span></sup><span
      v-if="index < authors.length-1">,&nbsp;</span>
    </span>
      <span v-if="abstract.content__studygroup">, {{abstract.content__studygroup}}</span>
    </div>
    <div>
      <span v-for="(affiliation, affilindex) in affiliations"><sup>{{affilindex}}</sup>{{getInstitute(affiliation)}}<span
        v-if="affilindex < Object.keys(affiliations).length">,&nbsp;</span></span>
    </div>
  </div>
</template>

<script>
  import {mapState, mapActions} from 'vuex'

  export default {
    name: "AuthorPreview",
    data() {
      return {};
    },
    created() {
      this.$store.dispatch('GET_AFFILIATIONS', this.$route.params.id);
    },
    methods: {
      ...mapActions([
        'GET_AFFILIATIONS'
      ]),
      getAuthorFirstname(name) {
        let template = this.settings.authors.authorline;
        if (!template.firstname.show) {
          return '';
        }
        if (template.firstname.cut < 1) {
          return name;
        }
        return this.generator(name, template.firstname.cut);
      },
      getAuthorLastname(name) {
        let template = this.settings.authors.authorline;
        if (!template.lastname.show) {
          return '';
        }
        if (template.lastname.cut < 1) {
          return name;
        }
        return this.generator(name, template.lastname.cut);
      },
      getInstitute(affiliation) {
        let institute = [];
        if (affiliation.name) {
          institute.push(affiliation.name);
        }
        if (affiliation.department) {
          institute.push(affiliation.department);
        }
        if (affiliation.city) {
          institute.push(affiliation.city);
        }
        if (affiliation.country_code) {
          institute.push(this.wording[0].country[affiliation.country_code]);
        }
        return institute.join(', ');
      },
      generator(name, length) {
        let finaldata = [];
        let splitSpace = name.split(' ');
        splitSpace.forEach((spacedName) => {
          if (spacedName.search("-") > 0) {
            finaldata.push(this.seperator(spacedName, length));
          } else {
            finaldata.push(this.cutter(spacedName, length))
          }
        });
        return finaldata.join('');
      },
      seperator(name, length) {
        let data = [];
        let splitSeperator = name.split('-');
        splitSeperator.forEach((seperatorName) => {
          data.push(this.cutter(seperatorName, length))
        });
        return data.join('-')
      },
      cutter(name, length) {
        return name.substring(0, length) + '.';
      }
    },
    computed: mapState([
      'authors', 'affiliations', 'wording', 'settings', 'abstract'
    ]),
  }
</script>

<style scoped>

</style>
